import { RotateCcw, Star, Copy } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";

// Badges for a lead whose number the CRM has seen before — trustedge
// customers/dedupe.py. Fed by the list API's enquiry_count, duplicate_count,
// related_customer_stage and last_enquiry_at.

const CUSTOMER_STAGES = ['Closed Won', 'Onboarded'];

const pill = "inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-semibold border whitespace-nowrap";

export const isExistingCustomerLink = (row) => CUSTOMER_STAGES.includes(row?.related_customer_stage);

export default function DuplicateBadges({ row, className }) {
    if (!row) return null;
    const enquiries = row.enquiry_count || 1;
    const linkedCustomer = isExistingCustomerLink(row);
    const dupes = row.duplicate_count || 0;
    if (enquiries < 2 && !linkedCustomer && !dupes) return null;

    return (
        <div className={cn("flex flex-wrap items-center gap-1 mt-0.5", className)}>
            {enquiries > 1 && (
                <span className={cn(pill, "bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-900/20 dark:text-brand-300 dark:border-brand-800/50")}
                      title={`This person has enquired ${enquiries} times${row.last_enquiry_at ? ` — last on ${new Date(row.last_enquiry_at).toLocaleDateString()}` : ''}`}>
                    <RotateCcw className="h-2.5 w-2.5" /> Came back {enquiries}×
                </span>
            )}
            {linkedCustomer && (
                <span className={cn(pill, "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800/50")}
                      title={`Same number as ${row.related_customer_name || 'an existing customer'} (${row.related_customer_stage})`}>
                    <Star className="h-2.5 w-2.5" /> Existing customer
                </span>
            )}
            {!linkedCustomer && dupes > 0 && (
                <span className={cn(pill, "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800/50")}
                      title={`${dupes} other lead${dupes === 1 ? '' : 's'} with the same number`}>
                    {/* Counts the OTHER leads only, the same ones the lead's
                        Enquiries tab lists; "2 leads" read as two others. */}
                    <Copy className="h-2.5 w-2.5" /> {dupes} other lead{dupes === 1 ? '' : 's'}, same number
                </span>
            )}
        </div>
    );
}
